// removed by extract-text-webpack-plugin
module.exports = {"thumb":"thumb","btn-remove-thumbnail":"btn-remove-thumbnail"};


//////////////////
// WEBPACK FOOTER
// ./components/business/styles.scss
// module id = ./components/business/styles.scss
// module chunks = 0